export const initClose = (option) => {
    const isShowClose = option.skip;
    const close = document.createElement("div");
    let play = () => { };
    let pause = () => { };
    if (isShowClose) {
        close.style.width = "46px";
        close.style.height = "26px";
        close.style.position = "absolute";
        close.style.zIndex = (option.zIndex + 99).toString();
        close.style.top = "16px";
        close.style.right = "16px";
        close.style.cursor = "pointer";
        close.style.background = "rgba(0,0,0,0.1)";
        close.style.borderRadius = "9999px";
        close.style.display = "flex";
        close.style.justifyContent = "center";
        close.style.alignItems = "center";
        close.style.color = "white";
        close.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
        close.style.fontSize = "12px";
        close.style.willChange = "transform";
        close.style.transform = "translateZ(0)";
        let num = option.skipAfter;
        let timer = null;
        let flag = false;
        const initNum = () => {
            if (num > 0) {
                close.innerText = num.toString();
            }
            else {
                option.onExposure();
                close.innerText = "Close";
            }
            clearTimeout(timer);
            if (num > 0) {
                timer = setTimeout(() => {
                    if (flag) {
                        num--;
                    }
                    initNum();
                }, 1000);
            }
        };
        initNum();
        close.addEventListener("click", (event) => {
            if (num == 0) {
                option.onClose && option.onClose();
            }
            event.stopPropagation();
            event.preventDefault();
        });
        play = () => {
            flag = true;
        };
        pause = () => {
            flag = false;
        };
    }
    return { close, play, pause };
};
export const initBox = (option) => {
    const box = document.createElement("div");
    box.tabIndex = 1;
    box.style.width = "100%";
    box.style.height = "100%";
    box.style.position = "relative";
    box.style.zIndex = option.zIndex.toString();
    box.style.minWidth = option.width + "px";
    box.style.minHeight = option.height + "px";
    return box;
};
//# sourceMappingURL=box.js.map